export default {
  required: {
    message: "This field is required",
    validator: function (value) {
      if (Array.isArray(value)) return value.length > 0;

      if (typeof value === "string") return value.trim().length > 0;

      return value || value === false || value === 0;
    },
  },
  htmlRequired: {
    message: "This field is required",
    validator: function (value) {
      if (!value) return false;

      // remove html from string
      value = value.replace(/<[^>]*>?/gm, "");
      return value.trim().length > 0;
    },
  },
  mustBeTrue: {
    message: "Required",
    validator: function (value) {
      return value;
    },
  },
  usPhone: {
    message: "This must be a valid US phone number",
    validator: function (number) {
      if (!number) return true;
      return /^1?\d{10}$/.test(number.toString().replace(/\D/g, ""));
    },
  },
  email: {
    message: "This must be a valid email address",
    validator: function (value) {
      if (!value) return true;
      return value
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
  },
  url: {
    message: "This must be a valid URL",
    validator: function (value) {
      if (!value) return true;
      try {
        new URL(value);
        return true;
      } catch (e) {
        return false;
      }
    },
  },
};
